import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

const PersonAddIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 17 19" {...props}>
      <path d="M8.66634 11.8754V18.332H0.333008C0.332749 17.3144 0.565442 16.3103 1.01326 15.3965C1.46107 14.4828 2.11212 13.6836 2.91652 13.0604C3.72092 12.4371 4.65732 12.0063 5.65397 11.8009C6.65062 11.5955 7.68106 11.621 8.66634 11.8754ZM6.99967 10.832C4.23717 10.832 1.99967 8.59453 1.99967 5.83203C1.99967 3.06953 4.23717 0.832031 6.99967 0.832031C9.76217 0.832031 11.9997 3.06953 11.9997 5.83203C11.9997 8.59453 9.76217 10.832 6.99967 10.832ZM11.9997 14.1654V11.6654H13.6663V14.1654H16.1663V15.832H13.6663V18.332H11.9997V15.832H9.49967V14.1654H11.9997Z" />
    </SvgIcon>
  );
};

export default PersonAddIcon;
